module.exports = __webpack_public_path__ + "static/media/dzielenie-sie.666e3272.jpg";